import { h } from "@stencil/core";
export class DcUiMetaNavLink {
    render() {
        const classes = {
            'meta-nav-link': true,
            'meta-nav-link--selected': this.selected,
            'meta-nav-link--badge': this.badge,
        };
        return (h("a", { key: '45f1f2d103bb144cc0fae40f0420b8a2a5317628', class: classes, href: this.href, target: this.target, rel: this.rel, "aria-label": this.label }, h("dc-ui-icon", { key: '731237122d611182c4d15464f73fd0b827a4a1e2', name: this.icon }), h("span", { key: '71d504e319f409c7b3b1a36bc40e0ae89cfec4ca' }, this.label)));
    }
    static get is() { return "dc-ui-meta-nav-link"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["../dc-ui-meta-nav-button/dc-ui-meta-nav-button.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["../dc-ui-meta-nav-button/dc-ui-meta-nav-button.css"]
        };
    }
    static get properties() {
        return {
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "label",
                "reflect": false
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TIcon",
                    "resolved": "\"dc_2D\" | \"dc_3D\" | \"dc_3D_printer\" | \"dc_3D_v2\" | \"dc_AI\" | \"dc_AR\" | \"dc_ActiveShuttle\" | \"dc_ActiveShuttle_platform-lift\" | \"dc_GoTo\" | \"dc_GoTo_frame\" | \"dc_add\" | \"dc_add_folder\" | \"dc_add_wishlist\" | \"dc_alert-error-filled\" | \"dc_alert-success-filled\" | \"dc_alert\" | \"dc_arrow_down\" | \"dc_arrow_left\" | \"dc_arrow_outward\" | \"dc_arrow_right\" | \"dc_arrow_right_2\" | \"dc_arrow_up\" | \"dc_arrows_vertical\" | \"dc_article\" | \"dc_axis\" | \"dc_backward_left\" | \"dc_backward_left_double\" | \"dc_basic_points\" | \"dc_battery-0\" | \"dc_battery-fail\" | \"dc_battery-loading\" | \"dc_blog_rexr\" | \"dc_book\" | \"dc_bookmark\" | \"dc_box_open\" | \"dc_brush\" | \"dc_bulb\" | \"dc_cad\" | \"dc_calculator\" | \"dc_calendar\" | \"dc_call\" | \"dc_callout_confirmation\" | \"dc_callout_error\" | \"dc_callout_hint\" | \"dc_callout_information\" | \"dc_cart\" | \"dc_certificate\" | \"dc_chart_line\" | \"dc_chat\" | \"dc_checkmark\" | \"dc_checkmark_active\" | \"dc_checkmark_disabled\" | \"dc_checkmark_inactive\" | \"dc_clipboard\" | \"dc_clock\" | \"dc_close\" | \"dc_cloud\" | \"dc_cloud_drive_error\" | \"dc_comment\" | \"dc_compass\" | \"dc_complete\" | \"dc_components\" | \"dc_configuration\" | \"dc_connection_status\" | \"dc_connection_status_2\" | \"dc_connectivity\" | \"dc_copy\" | \"dc_countertarget\" | \"dc_customerservice\" | \"dc_delete\" | \"dc_device\" | \"dc_document\" | \"dc_document_bmp\" | \"dc_document_csv\" | \"dc_document_doc\" | \"dc_document_dwg\" | \"dc_document_dxf\" | \"dc_document_mp4\" | \"dc_document_pdf\" | \"dc_document_plain\" | \"dc_document_png\" | \"dc_document_ppt\" | \"dc_document_sat\" | \"dc_document_selector\" | \"dc_document_step\" | \"dc_document_txt\" | \"dc_document_vrml\" | \"dc_document_xls\" | \"dc_document_xml\" | \"dc_down\" | \"dc_down_double\" | \"dc_download\" | \"dc_duplicate\" | \"dc_edit\" | \"dc_excavator\" | \"dc_expansion_arrows\" | \"dc_export\" | \"dc_eye\" | \"dc_eye_hide\" | \"dc_facebook_b\" | \"dc_faq02\" | \"dc_feedback\" | \"dc_field_service\" | \"dc_film\" | \"dc_filter_01\" | \"dc_filter_02\" | \"dc_flashlight\" | \"dc_folder\" | \"dc_folder_bookmark_empty\" | \"dc_folder_bookmark_full\" | \"dc_folder_document_empty\" | \"dc_folder_document_full\" | \"dc_folder_image_empty\" | \"dc_folder_image_full\" | \"dc_folder_open\" | \"dc_forward_right\" | \"dc_forward_right_double\" | \"dc_fullscreen_exit\" | \"dc_gerat\" | \"dc_github\" | \"dc_globe\" | \"dc_googleplus_b\" | \"dc_grid_view\" | \"dc_half_complete\" | \"dc_history\" | \"dc_home\" | \"dc_i_shipping_stock\" | \"dc_i_si\" | \"dc_i_sum\" | \"dc_imagery\" | \"dc_imprint\" | \"dc_industry_data_set\" | \"dc_info\" | \"dc_instagram_b\" | \"dc_kinematic\" | \"dc_label\" | \"dc_less_minimize\" | \"dc_link\" | \"dc_linkedin_b\" | \"dc_list_mobile\" | \"dc_list_view\" | \"dc_loading\" | \"dc_locator\" | \"dc_locator_spot\" | \"dc_look_closed\" | \"dc_mail\" | \"dc_material_number\" | \"dc_message\" | \"dc_microsoft-teams\" | \"dc_moneybagwithcoin\" | \"dc_motion\" | \"dc_move_left\" | \"dc_move_right\" | \"dc_music\" | \"dc_my-project\" | \"dc_network\" | \"dc_no_preview\" | \"dc_notification-01\" | \"dc_notification-02\" | \"dc_offline\" | \"dc_online\" | \"dc_options\" | \"dc_organize\" | \"dc_overview\" | \"dc_packet_solution\" | \"dc_palette\" | \"dc_paperclip\" | \"dc_paperplane\" | \"dc_parking\" | \"dc_pause\" | \"dc_pin_classic\" | \"dc_play\" | \"dc_plc\" | \"dc_podcast\" | \"dc_podcast_2\" | \"dc_print\" | \"dc_product\" | \"dc_question\" | \"dc_redo\" | \"dc_repairs\" | \"dc_reset\" | \"dc_robot\" | \"dc_rocket\" | \"dc_routing\" | \"dc_rss\" | \"dc_ruler\" | \"dc_save\" | \"dc_save_as\" | \"dc_screenshot\" | \"dc_search\" | \"dc_service\" | \"dc_service_assembly\" | \"dc_service_stock\" | \"dc_settings\" | \"dc_share\" | \"dc_shift_arrows\" | \"dc_sink\" | \"dc_size\" | \"dc_skyscraper\" | \"dc_solution\" | \"dc_sort\" | \"dc_source\" | \"dc_spare_parts\" | \"dc_spreadsheet\" | \"dc_status\" | \"dc_status_error\" | \"dc_status_hint\" | \"dc_status_information\" | \"dc_status_success\" | \"dc_status_warning\" | \"dc_stop\" | \"dc_stop_filled\" | \"dc_structure\" | \"dc_trophy\" | \"dc_twitter-X\" | \"dc_twitter_b\" | \"dc_uncomplete\" | \"dc_undo\" | \"dc_up\" | \"dc_up_double\" | \"dc_upload\" | \"dc_user\" | \"dc_video\" | \"dc_view_3d\" | \"dc_view_3d_back\" | \"dc_view_3d_bottom\" | \"dc_view_3d_front\" | \"dc_view_3d_left\" | \"dc_view_3d_right\" | \"dc_view_3d_top\" | \"dc_volume_high\" | \"dc_warning\" | \"dc_wechat_b\" | \"dc_weibo_b\" | \"dc_whatsapp_b\" | \"dc_whistle\" | \"dc_wiki_page\" | \"dc_wireless_safety\" | \"dc_wishlist\" | \"dc_wlan\" | \"dc_xing_b\" | \"dc_youtube_b\" | \"dc_zip\" | \"dc_zoom_in\" | \"dc_zoom_out\"",
                    "references": {
                        "TIcon": {
                            "location": "import",
                            "path": "../../../components",
                            "id": "src/components.d.ts::TIcon"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "icon",
                "reflect": false
            },
            "badge": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "badge",
                "reflect": false
            },
            "selected": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "selected",
                "reflect": false
            },
            "href": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "href",
                "reflect": false
            },
            "target": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "'_blank' | '_self' | '_parent' | '_top'",
                    "resolved": "\"_blank\" | \"_parent\" | \"_self\" | \"_top\"",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "target",
                "reflect": false
            },
            "rel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "rel",
                "reflect": false
            }
        };
    }
}
//# sourceMappingURL=dc-ui-meta-nav-link.js.map
